import {isArrayNullUndefinedOrEmpty, isNullOrUndefined} from "../../../services/Validator";
import CoursesSubthemesContentHeader from "./CoursesSubthemesContentHeader";
import SystemScreenError from "../../errors/SystemScreenError";
import {kFlashSubthemesError} from "../../../constants/errors";
import CoursesNoGradeSelected from "./CoursesNoGradeSelected";
import CoursesSubthemesLoader from "../../loaders/courses/CoursesSubthemesLoader";
import CoursesLevelAsList from "../../lists/courses/CoursesLevelAsList";
import CoursesSubthemesList from "../../lists/courses/CoursesSubthemesList";

export default function CoursesSubthemesContent({ selectedSubtheme,
                                                  selectedGrade,
                                                  isSubthemesLoading,
                                                  subthemesError,
                                                  subthemes,
                                                  levelAs,
                                                  selectSubtheme,
                                                  pickLevelA,
                                                  clearLevelAs,
                                                  selectedLevelAs }) {
    // Used in CoursesCoreContent to display Subthemes and LevelAs
    // related components in desktop and tablet modes

    // PROPERTIES
    const subthemesCount = subthemes?.length
    const levelAsCount = levelAs?.length

    // BUILD
    if (!isNullOrUndefined(subthemesError))
        return <SystemScreenError error={subthemesError} />
    if (isSubthemesLoading)
        return <CoursesSubthemesLoader />
    if (isNullOrUndefined(selectedGrade))
        return <CoursesNoGradeSelected />
    if (isArrayNullUndefinedOrEmpty(subthemes))
        return <SystemScreenError error={kFlashSubthemesError} />
    return (
        <div className={"overflow-auto animate-appearSlow w-full grow flex flex-col justify-start shadow-[inset_0px_1px_2px_rgba(82,96,120,1)] mt-[24px]"}>
            <CoursesSubthemesContentHeader subthemesCount={subthemesCount}
                                           levelAsCount={levelAsCount} />
            <div className={"overflow-auto w-full grow flex bg-backgroundLight3 border-1 border-backgroundLight5"}>
                <CoursesSubthemesList subthemes={subthemes}
                                        selectSubtheme={selectSubtheme}
                                        selectedSubtheme={selectedSubtheme} />
                <CoursesLevelAsList levelAs={levelAs}
                                    selectedLevelAs={selectedLevelAs}
                                    pickLevelA={pickLevelA}
                                    clearLevelAs={clearLevelAs} />
            </div>
        </div>
    );
}